module.exports = __webpack_public_path__ + "static/widget-demo-c004d017db2b0abcc74ff30eb5c06342.gif";